export default __webpack_public_path__ + "/images/2386586da9dd8eb2cdd7093296918a3e.svg";